<template>
  <LoadingDiv v-if="!isReady" />
  
  <template v-else>
    <section class="tariff-band-shell">
      <div class="tariff-band-card" :class="{ 'has-error': error }">
        <div>
          <label class="active teal-text">Current Provider Plan</label>
          <h6>{{ plans.find(x => x.id === planId)?.name || "Plan not available" }}</h6>
          <p>This is the current plan band used as the tariff base for this provider.</p>
        </div>
        <span class="tariff-band-status">
          <i class="tiny material-icons">check_circle</i>
          Current Band
        </span>
      </div>
    </section>
  </template>
</template>

<script>
import { onMounted, onUpdated, ref, computed } from "vue";
import getItems from "@/composables/getItems";
import LoadingDiv from "@/components/LoadingDiv.vue";
import M from "materialize-css";

export default {
  name: "ChangeTariffBandComponent",
  components: { LoadingDiv },
  props: ["providerId", "planId"],
  setup() {
    const response = ref(null);
    const isReady = ref(false);
    const error = ref(null);


    // get function
    const getItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready
        isReady.value = true;
      })();
    };

    // drop down
    onMounted(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

    // drop down
    onUpdated(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

    // starter
    onMounted(() => {
      // get plans
      getItemsFromApi("plan/private");
    });

    // output results
    const plans = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    return {
      isReady,
      error,
      plans,
    };
  },
};
</script>

<style scoped>
.tariff-band-shell {
  display: grid;
  gap: 14px;
}

.tariff-band-card {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e3eaed;
  border-radius: 6px;
  box-shadow: 0 18px 32px -30px rgba(38, 50, 56, 0.72);
  display: flex;
  gap: 18px;
  justify-content: space-between;
  padding: 20px;
}

.tariff-band-card.has-error {
  background: #ffebee;
  border-color: #ffcdd2;
}

.tariff-band-card label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.tariff-band-card h6 {
  color: #263238;
  font-size: 1.08rem;
  font-weight: 600;
  line-height: 1.35;
  margin: 0;
}

.tariff-band-card p {
  color: #607d8b;
  line-height: 1.55;
  margin: 7px 0 0;
}

.tariff-band-status {
  align-items: center;
  background: #e8f3f2;
  border: 1px solid #9bd2cb;
  border-radius: 999px;
  color: #00695c;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.78rem;
  font-weight: 700;
  gap: 6px;
  padding: 8px 11px;
}

@media only screen and (max-width: 700px) {
  .tariff-band-card {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
